import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialElementsModule } from '../material-elements.module';
import { HeaderComponent } from './comman/header/header.component';
import { FooterComponent } from './comman/footer/footer.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import  'zone.js';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ConfigService } from './config.service';



const appConfig=(config:ConfigService)=>{

  return()=>{
    return config.loadConfig()
  }
}
const jsonConfig=  (config:ConfigService)=>{

     return()=>{
      return config.jsonConfigData();
     }

}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    MaterialElementsModule,
    HttpClientModule,
    MatSnackBarModule
  ],


  providers: [
    {provide:APP_INITIALIZER,useFactory:appConfig,multi:true,deps:[ConfigService]},
    {provide:APP_INITIALIZER,useFactory:jsonConfig,multi:true,deps:[ConfigService]}

  ],

  bootstrap: [AppComponent]


})


export class AppModule { }
